<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <div class="text-muted">
    {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.current_configuration.label' | translate }}
    <strong>{{ callFlow().name }}</strong>
    @if (callFlow().isAfterHoursCallFlow) {
      <div class="d-flex align-items-center py-3 gap-2 mb-0" data-automation="after-hours-schedule-alert">
        <i [class]="ZiroIcons.CIRCLE_EXCLAMATION"></i>
        <div>
          {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.after_hours.alert' | translate }}
        </div>
      </div>
    }
  </div>
</ziro-collapsible-section-card>

@if (callFlow().isHoliday && callFlow().holiday) {
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <ziro-holiday-call-flow-form
      [holidayCallFlow]="callFlow()"
      [allHolidays]="allHolidays()"
      (callFlowNameChange)="callFlowNameChange.emit($event)"
      (validityChange)="onHolidayValidityChange($event)"
    ></ziro-holiday-call-flow-form>
  </ziro-collapsible-section-card>
}

<!-- Greetings -->
<ziro-call-flow-greetings
  [tenantId]="tenantId()"
  [prompt]="currentGreeting()"
  [pendingGreetingOption]="currentPendingGreetingOption()"
  [dataAutomation]="'call-flow-greetings'"
  (greetingUpdate)="greetingUpdate.emit($event)"
  (validityChange)="onGreetingsValidityChange($event)"
></ziro-call-flow-greetings>

<!-- Weekly schedule -->
@if (!callFlow().isHoliday && !callFlow().isAfterHoursCallFlow) {
  <ziro-weekly-schedule
    [schedule]="currentSchedule()"
    [callFlow]="callFlow()"
    (scheduleChange)="onScheduleChange($event)"
  ></ziro-weekly-schedule>
} @else if (callFlow().isAfterHoursCallFlow) {
  <ziro-weekly-schedule
    [schedule]="currentSchedule()"
    [callFlow]="callFlow()"
    (scheduleChange)="onScheduleChange($event)"
    (selectBusinessHoursFlow)="navigateToBusinessHours.emit()"
  ></ziro-weekly-schedule>
}

<!-- Destination Buttons -->
<ziro-call-flow-destinations-form
  [attr.data-automation]="callFlow().isHoliday ? 'call-flow-holiday-destinations-form' : 'call-flow-destinations-form'"
  [tenantId]="tenantId()"
  [callFlow]="callFlow()"
  (greetingUpdate)="greetingUpdate.emit($event)"
></ziro-call-flow-destinations-form>
